import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ReconhecimentoFacialController from '@/assets/ts/controller/ReconhecimentoFacialController';
import CardAnexoFoto from '@/components/biometria/CardAnexoFoto/CardAnexoFoto.vue';
import CameraController from '@/assets/ts/controller/CameraController';


@Component({
  name: 'NovoRegistroBiometriaFacialPopup',
  components: {
    TkForm,
    CardAnexoFoto
  },
})
class NovoRegistroBiometriaFacialPopup extends Vue {

  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: null })
  private readonly nrParcnegocio: any;

  @Prop({ default: false })
  private readonly isEdit: boolean;

  @Prop({ default: null })
  private readonly nrFaceId: any;

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}

  private internalValue = false;
  private isOpencardAnexoFoto = true;
  private showCamera = false;
  private isOpenModalTirarFoto = false;
  private photoBase64First = null;
  private photoBase64Second = null;
  private loading = false;
  private contadorFoto = 0;

  // Detecção
  private isDetectionStarted = false;
  private IsPhotoInProgress = false;
  private faceDetections = {
    quantity: 0,
    isDetect: false
  };
  private isOneFaceDetection = false;
  private isvisibleMessage = false;
  private messageFaceDection = '';

  private intervaloTimerFoto = null;
  private intervaloFoto = null;


  private messages = {
    cameraAccessError: 'Não foi possível acessar a câmera. Verifique as permissões do navegador.',
  }

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;
  }

  // #region [ METHODS ]
  private closePopup() {
    this.internalValue = false;
    this.clearPhotos();
    this.cancelDectationFlow();

    this.emitInput(this.internalValue);
  }

  private cameraConfig = {
    cameraAreaId: 'camera__area',
    videoTagId: 'camera__area--view',
    canvasTagId: 'camera__area--sensor',
    imgTagId: 'camera_area--visualizer',
    canvasFaceTagId: 'camera__area--face',
  };

  private cameraParams = {
    IDs: {
      video: `#${this.cameraConfig.videoTagId}`,
      canvas: `#${this.cameraConfig.canvasTagId}`,
      img: `#${this.cameraConfig.imgTagId}`,
      canvasFace: `#${this.cameraConfig.canvasFaceTagId}`,
    },
  };

  private camera = new CameraController(
    this.cameraParams.IDs.video,
    this.cameraParams.IDs.canvas,
    this.cameraParams.IDs.img,
    this.cameraParams.IDs.canvasFace,
  );
  
  private screenSetup = {
    defaultScreenVisualization: {
      systemVariables: {
        showCamera: false,
      },
      camera: 'off',
    },
    defaultCameraVisualization: {
      systemVariables: {
        showCamera: true,
      },
      camera: 'on',
    },
  };

  private pictureConfig = {
    timeToTakePhoto: 1500,
    timeToSecondPhoto: 1000,
  };

  private screenSetupConfig = {
    actions: {
      camera: {
        on: async () => await this.camera.initTransmitionCameraDevice(),
        off: () => CameraController.stopUsingCameraDevice(this.cameraParams.IDs.video),
      },
    },
  };

  private get cardTitle(): string {
    return 'Cadastro de Biometria Facial';
  }

  private get fields(): any[] {
    const fields = [
      {
        name: '_eula',
        label: `
          Este formulário registra a manifestação livre, informada e inequívoca pela qual o Funcionário
          concorda com o tratamento de seus dados pessoais para finalidade específica,
          em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD).
          Li e concordo.`,
        type:'checkbox',
        size: 12,
        required: true,
        valueToTrue: true,
        valueToFalse: null,
      },
    ];

    return fields;
  }

  private async created() {
    await this.onCreated();
    await this.initModulesReconhecimentoFacial();
  }

  private async onCreated() {
    try {
      const cameraAccess = await CameraController.checkCameraAccess();
    } catch (error) {
      SnackbarUtils.showMessage(error as string, SnackbarUtils.TYPE_ERROR);
    } 
  }

  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private onFieldInput(fieldName, value) {

  }

  private async setUpScreen(screenSetup = null) {
    try {
      if (!screenSetup) {
        screenSetup = this.screenSetup.defaultScreenVisualization;
      }

      // set camera funcionality
      await this.screenSetupConfig.actions.camera[screenSetup.camera]();

      // set screen control variables
      for (const param in screenSetup.systemVariables) {
        this[param] = screenSetup.systemVariables[param];
      }
    } catch (err) {
      throw err;
    }
  }

  private snapShotEffect() {
    return new Promise<void>((resolve, reject) => {
      const video: HTMLElement = document.querySelector('#camera__area');

      video.style.visibility = 'hidden';
      setTimeout(() => {
        video.style.visibility = 'visible';
        resolve();
      }, 100);
    });
  }

  private async initModulesReconhecimentoFacial () {
    try {
      await CameraController.initLoadFaceModules();
    } catch (error) {
      const msg = error as string;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR, 7000);
    }
  }

  private async openTirarFoto() {
    try {
      this.openModalFoto();
      await this.sleep(300);      
      await this.setUpScreen(this.screenSetup.defaultCameraVisualization);
    } catch (error) {
      SnackbarUtils.showMessage(error as string, SnackbarUtils.TYPE_ERROR);
      this.closeModalFoto();
    }
  }

  private closeCamera() {
    this.closeModalFoto();
    this.cancelDectationFlow();
  }

  private openModalFoto() {
    this.isvisibleMessage = false;
    this.messageFaceDection = '';
    this.isOpenModalTirarFoto = true;
    this.showCamera = true;
  }

  private closeModalFoto() {
    this.isOpenModalTirarFoto = false;
    this.showCamera = false;
    this.cancelDectationFlow();
  }

  private cancelDectationFlow() {
    this.clearIntervals();
    this.isDetectionStarted = false;
    this.IsPhotoInProgress = false;
    this.camera.cancelFaceDetection();
    this.cancelEventFaceDetection();
    this.isvisibleMessage = false;
    this.messageFaceDection = '';
    CameraController.stopUsingCameraDevice(this.cameraParams.IDs.video);
  }

  private showTimerFoto() {
    this.isvisibleMessage = true;
    this.contadorFoto = 3;
    this.messageFaceDection = this.contadorFoto.toString();

    clearInterval(this.intervaloTimerFoto);

    this.intervaloTimerFoto = setInterval(() => {
      if (this.contadorFoto > 0) {
        this.contadorFoto--;
        this.messageFaceDection = this.contadorFoto.toString();
      } else {
        clearInterval(this.intervaloTimerFoto);
        this.contadorFoto = 0;
      }
    }, 1000);
  }

  private async checkAcessCamera() {
    try {
      const cameraAccess = await CameraController.checkCameraAccess();
    } catch (err) {
      SnackbarUtils.showMessage(this.messages.cameraAccessError, SnackbarUtils.TYPE_ERROR);
    } 
  }

  private sleep(ms) {
    return new Promise((resolve: any) => setTimeout(resolve, ms));
  }
  
  private clearPhotos() {
    this.photoBase64First = null;
    this.photoBase64Second = null;
  }

  private get validate(): (setErrorColor?: boolean) => boolean {
    return (this.$refs.form as any).validate;
  }

  private async save() {

    const isRostoValid = await this.verificaExisteRostoImagem();
    if(!isRostoValid) return false;
  
    const nrParcNegocio = this.nrParcnegocio;
    if (!this.validate(true) || !this.photoBase64First && !this.photoBase64Second) {
      this.alertAllFieldsIsRequired();

      return;
    }

    this.closeModalFoto();
    const success = await ReconhecimentoFacialController.verificaRostoEncodaECompara(this.photoBase64First, this.photoBase64Second);

    if(!success) {
      const message = 'Por favor, solicito que forneça outra foto para o cadastro da biometria, pois a atual não atende aos requisitos necessários.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      return;
    }

    if(this.isEdit) {
      await ReconhecimentoFacialController.updateHashFacial(this.nrFaceId, nrParcNegocio, this.photoBase64Second);
    } else {
      await ReconhecimentoFacialController.saveHashFacial(nrParcNegocio, this.photoBase64Second);
    }

    this.closePopup();
    const message = 'Biometria cadastrada com sucesso';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    this.emitAfterSave();
  }

  private alertAllFieldsIsRequired() {
    const message = 'Favor preencher todos os campos obrigatórios!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
  }

  private async iniciarDeteccaoFacial() {
    try {
      this.isDetectionStarted = true;

      this.camera.faceDetectLive();
      this.handleOnFaceDetection();
  
    } catch (error) {
      this.isDetectionStarted = false;
      this.camera.offDetect('detections', detections => {
        console.log('Eventos de detecção cancelados');
      }); 
    }
  }

  private handleOnFaceDetection() {
    this.camera.onDetect('detections', (detections: []) => {

      if(!detections.length) {
        this.isvisibleMessage = true;
        this.messageFaceDection = `Aguardando detecção de face...`;
        this.clearIntervals();
        this.IsPhotoInProgress = false;
        return;
      }

      if(detections.length > 1) {
        this.handleMultipleFacesDetected(detections);
        return;
      }

      if(!this.IsPhotoInProgress) {
        this.handleTakingPhoto();
      }

    }); 
  }

  private handleTakingPhoto() {
    this.IsPhotoInProgress = true;

    this.showTimerFoto();

    this.intervaloFoto = setTimeout(async () =>  {
      const picture1 = await this.camera.takePicture(false);
      this.photoBase64First = picture1;

      // Aguarda 1s para tirar a segunda foto
      await this.sleep(this.pictureConfig.timeToSecondPhoto);

      const picture2 = await this.camera.takePicture();
      this.photoBase64Second = picture2;

      this.isDetectionStarted = false;
      this.closeCamera();

    }, 2000);

  }

  private handleMultipleFacesDetected(detections: []) {
    this.faceDetections.quantity = detections.length;
    this.isvisibleMessage = true;

    this.messageFaceDection = `Foram detectadas ${detections.length} faces.`;
    this.clearIntervals();
    this.IsPhotoInProgress = false;
  }

  private cancelEventFaceDetection() {
    this.camera.offDetect('detections', detections => {
      console.log('Eventos de detecção cancelados');
    }); 
  }

  private clearIntervals() {
    clearInterval(this.intervaloTimerFoto);
    clearInterval(this.intervaloFoto);
  }

  private async verificaExisteRostoImagem() {
    const detections = await this.camera.detectFacesInImage(this.photoBase64Second);
    let message = '';

    if(!detections || !detections.length) {
      message = 'Não foi detectado nenhum rosto nesta imagem. Por favor, verifique se a foto está clara e bem iluminada, e tente novamente.'
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR, 7000);
      return false;
    }

    if(detections.length > 1) {
      message = `Detectamos ${detections.length} rostos na imagem. Por favor, garanta que apenas um rosto esteja visível na foto para uma análise precisa.`
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR, 7000);
      return false;
    }

    if(detections[0].score < 0.85) {
      message = `O rosto detectado na imagem não possui uma qualidade ideal para o cadastro da biometria facial. Por favor, certifique-se de que o rosto esteja bem iluminado e claramente visível, para uma captura precisa.`
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR, 10000);
      return false;
    }

    return true;
  }

  private async comparaFaces() {
    await this.camera.compareFaces(this.photoBase64First, this.photoBase64Second);
    return true;
  }

}

export default NovoRegistroBiometriaFacialPopup;